import type { UiActionParameters } from '../parameters/ui-action'

import { parameters } from '../parameters/player-recommendations-ui-action'
import { UiActionEvent } from './ui-action'

export class PlayerRecommendationsUiActionEvent extends UiActionEvent {
  parameters = parameters

  constructor(uiActionParams: UiActionParameters) {
    super(uiActionParams)
  }
}
